import {
  React,
  useRef, 
  useState,
  useEffect
} from 'react';

import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Select,
  Slider, 
  Tab,
  Typography ,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';


const TrackingCalibrationPanel = ({title, temp}) =>{


    const gridCellStyle = {        
        paddingTop:"0px", 
        paddingLeft:"0px",
        display: "flex",
        justifyContent: "center", /* Center horizontally */
        alignItems: "center",     /* Center vertically */   
    }

    const upDownButtonStyle = {
        minWidth:"2%",
        width:"10%",
        color:"black",      
        backgroundColor:"#bbbbbb"
    }

    const leftRightButtonStyle = {
        minWidth:"1%",
        width:"100%",
        color:"black",      
        backgroundColor:"#bbbbbb"
    }

	return (
		<Grid
		    style={{border:"1px solid #cccccc", height:"259px",padding:"2px", margin:"1px"}}
        	container
        	spacing={1}
    	>
    	<Grid 
         	item
     		lg={12}
            md={12}
            xl={12}
            xs={12}
        >
        	<InputLabel shrink>Tracking Calibration</InputLabel>
        </Grid>
        <Grid 
            style={gridCellStyle}
         	item
     		lg={12}
            md={12}
            xl={12}
            xs={12}
        >
    		<Button  style={upDownButtonStyle} variant="contained">&uarr;</Button>
        </Grid>
        <Grid 
        style={gridCellStyle}
         	item
     		lg={2}
            md={2}
            xl={1}
            xs={3}
        >
       		<Button  style={leftRightButtonStyle} variant="contained">&larr;</Button>
        </Grid>
        <Grid 
        style={gridCellStyle}
         	item
     		lg={8}
            md={8}
            xl={10}
            xs={6}
        >
        <svg width="100%" height="100%" version="1.1">
            <line x1="0%" y1="50%" x2="100%" y2="50%" stroke="black" stroke-width="2" />
            <line x1="50%" y1="0%" x2="50%" y2="100%" stroke="black" stroke-width="2" />
            <circle cx="50%" cy="50%" r="10" fill="red" />
        </svg>
        </Grid>
        <Grid 
        style={gridCellStyle}
         	item
     		lg={2}
            md={2}
            xl={1}
            xs={3}
        >
        	<Button  style={leftRightButtonStyle} variant="contained">&rarr;</Button>
        </Grid>
         <Grid 
        style={gridCellStyle}
         	item
     		lg={12}
            md={12}
            xl={12}
            xs={12}
        >
        	<Button  style={upDownButtonStyle} variant="contained">&darr;</Button>
        </Grid>
    </Grid>

	)
}

TrackingCalibrationPanel.propTypes = {
};

export default TrackingCalibrationPanel;